import {Scan} from '@qid/core';
import {CollectionTemplate} from "../../collection-template";
import {Organisation} from "../../organisation";
import {ScannerTemplateOptions} from "../../../models/scanner-template-options";

export class Scanner {
  createdBy: string;

  createTime: string;

  template: CollectionTemplate;

  templateId: string;

  qr: string;

  scans: Scan[];
  _id: any;
  scannerTemplateOptions: ScannerTemplateOptions[] = [];
  optionsTitle: string;
  commonTitle: string = "";
  org: Organisation | any;

  public static getCompleteQrURL(qr) {
    //TODO : FIX
    return 'environment.collectUrl + qr'
  }
}



